export default __webpack_public_path__ + "static/media/hand-background.6b46ef98.png";